"use strict";

import angular from "angular";

import { resolveColorPath } from "./themes/colors-charts/color-token";

/**
 * Este serviço resolvia `familia.tom` contra o `style-dictionary/properties/color/base.json`,
 * que é outra paleta: lá `cyan.medium` é `rgba(0, 245, 255, 1)` (ciano elétrico) e
 * `purple.medium` é `rgba(213, 0, 255, 1)` (magenta). O dashboard renderiza `#1a72a8` e
 * `#7060b4`, do `colors-charts-default`.
 *
 * Como o único consumidor é o `ChartSeries` — que alimenta o `ChartStructure` do `nu-chart`,
 * o preview das telas de criação de indicador customizado —, o contador via no preview uma
 * cor e no dashboard outra. Agora os dois leem a mesma paleta.
 */
export class ColorService {
    constructor(ThemesService) {
        this.ThemesService = ThemesService;
    }

    backgroundColor = (className) => {
        const classes = {
            positive: "bg-positive",
            negative: "bg-negative",
            error: "bg-inconsistency",
            warning: "bg-warning",
            neutro: "bg-neutro",
            inconsistency: "bg-inconsistency",
            "positive-linear": "bg-positive-linear",
            "negative-linear": "bg-negative-linear",
            "error-linear": "bg-error-linear",
            "warning-linear": "bg-warning-linear",
            "neutro-linear": "bg-neutro-linear",
            "basic-linear": "basic-linear",
            "inconsistency-linear": "bg-inconsistency-linear"
        };
        return classes[className];
    };

    backgroundImage = (backgroundColor) => {
        const images = {
            "bg-positive": "bg-image-cyan",
            "bg-negative": "bg-image-purple",
            "bg-neutro": "bg-image-magenta",
            "bg-error": "bg-image-error",
            "bg-warning": "bg-image-warning"
        };

        return images[backgroundColor];
    };

    /**
     * Identify a color by your pathName in json
     * @public
     * @param {String} path
     * @return {String} Value of path
     */
    colorByPath(pathName) {
        return resolveColorPath(
            this.ThemesService.getDashboardTheme(),
            this.ThemesService.getDashboardTheme("default"),
            pathName,
            this.ThemesService.getTheme()
        );
    }
}
angular
    .module("nucont.shared")
    .service("ColorService", ["ThemesService", ColorService]);
